export default {
  // 標題
  shareCanvas: "分享畫布",

  // 加載
  loading: "拼命加載中",

  // 分享權限
  sharePermission: "分享權限",
  viewOnly: "僅查看",
  viewOnlyDescription: "不需要登錄，輸入密碼即可訪問",
  copyable: "可複製",
  copyableDescription: "需要登錄，允許用戶複製畫布，輸入密碼即可訪問",

  // 有效期
  validity: "有效期",
  pleaseSelect: "請選擇",
  oneDay: "1天",
  threeDays: "3天",
  sevenDays: "7天",
  fourteenDays: "14天",
  thirtyDays: "30天",

  // 地址隱藏
  addressMasking: "地址隱藏",

  // 訪問密碼
  accessPassword: "訪問密碼",

  // 按鈕
  copyLink: "複製鏈接",

  // 消息
  copySuccess: "複製成功",
};
